import jsPDF from 'jspdf';
import { cargarLogoAmzedel, NOMBRE_FARMACIA, SISTEMA_DESCRIPCION } from '@/lib/marca';
import { dibujarMarca } from '@/lib/pdf/encabezado';
import type { VentaRow } from '@/lib/ventas/types';

/**
 * Comprobante térmico (80mm) con identidad AMZEDEL y su logo.
 */
export async function generarComprobanteVenta(venta: VentaRow): Promise<void> {
  const doc = new jsPDF('p', 'mm', [80, 170]);
  const pageWidth = 80;
  let y = 8;

  const logo = await cargarLogoAmzedel();
  if (logo) {
    const size = 14;
    const ratio = logo.width / logo.height || 1;
    let w = size;
    let h = size;
    if (ratio > 1) h = size / ratio;
    else w = size * ratio;
    try {
      doc.addImage(logo.dataUrl, logo.format, (pageWidth - w) / 2, y - 2, w, h);
      y += h + 3;
    } catch {
      y += 2;
    }
  } else {
    dibujarMarca(doc, null, (pageWidth - 11) / 2, y - 2, 11);
    y += 12;
  }

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.setTextColor(31, 46, 44);
  doc.text(NOMBRE_FARMACIA, pageWidth / 2, y, { align: 'center' });
  y += 4.5;

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(6);
  doc.setTextColor(130, 130, 130);
  doc.text(SISTEMA_DESCRIPCION, pageWidth / 2, y, { align: 'center' });
  y += 3;
  doc.text('COMPROBANTE DE VENTA', pageWidth / 2, y, { align: 'center' });
  y += 4.5;

  doc.setDrawColor(200, 200, 200);
  doc.line(5, y, pageWidth - 5, y);
  y += 4;

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(6);
  doc.setTextColor(80, 80, 80);
  doc.text(`Fecha: ${new Date(venta.fecha).toLocaleString('es-ES')}`, 5, y);
  y += 3;
  doc.text(`Método: ${venta.metodo_pago}`, 5, y);
  y += 3;
  if (venta.nombre_nit) {
    doc.text(`Cliente: ${venta.nombre_nit}`, 5, y);
    y += 3;
    doc.text(`NIT/CI: ${venta.numero_nit || '—'}`, 5, y);
    y += 3;
  }

  doc.line(5, y, pageWidth - 5, y);
  y += 3;

  if (venta.detalle && venta.detalle.length > 0) {
    doc.setFontSize(5);
    doc.setFont('helvetica', 'bold');
    doc.text('Producto', 5, y);
    doc.text('Cant', 42, y);
    doc.text('P.Unit', 52, y);
    doc.text('Subtotal', 65, y);
    y += 3;
    doc.setFont('helvetica', 'normal');

    venta.detalle.forEach((d) => {
      if (y > 150) {
        doc.addPage();
        y = 8;
      }
      const name = d.producto_nombre.length > 20 ? `${d.producto_nombre.substring(0, 18)}..` : d.producto_nombre;
      doc.text(name, 5, y);
      doc.text(d.cantidad.toString(), 42, y);
      doc.text(`Bs.${Number(d.precio_unitario).toFixed(2)}`, 52, y);
      doc.text(`Bs.${Number(d.subtotal).toFixed(2)}`, 65, y);
      y += 3;
    });
  } else {
    doc.setFontSize(6);
    doc.setTextColor(130, 130, 130);
    doc.text('Sin productos registrados', pageWidth / 2, y, { align: 'center' });
    y += 4;
  }

  doc.setDrawColor(200, 200, 200);
  doc.line(5, y, pageWidth - 5, y);
  y += 4;

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8);
  doc.setTextColor(31, 46, 44);
  doc.text(`TOTAL: Bs. ${Number(venta.total).toFixed(2)}`, pageWidth / 2, y, { align: 'center' });
  y += 4;

  if (venta.metodo_pago === 'Efectivo' && Number(venta.monto_recibido) > 0) {
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(6);
    doc.setTextColor(80, 80, 80);
    doc.text(`Recibido: Bs. ${Number(venta.monto_recibido).toFixed(2)}`, pageWidth / 2, y, { align: 'center' });
    y += 3;
    doc.text(`Cambio: Bs. ${Number(venta.cambio).toFixed(2)}`, pageWidth / 2, y, { align: 'center' });
    y += 4;
  }

  doc.setFontSize(5);
  doc.setTextColor(150, 150, 150);
  doc.text('Documento generado electrónicamente', pageWidth / 2, y, { align: 'center' });

  const fecha = new Date(venta.fecha).toLocaleDateString('es-ES').replace(/\//g, '-');
  doc.save(`Comprobante_${fecha}_${venta.id.substring(0, 6)}.pdf`);
}